import { Stack, Box, useTheme } from '@mui/material';
import { MHMTypography } from '../MHM/MHMTypography';
import { LegendProps } from 'recharts';

export const LegendContent = (props: LegendProps) => {
  const { payload } = props;
  const { palette } = useTheme();

  if (!payload || payload.length === 0) return null;

  const lhs = payload.filter(item => item.type !== 'rect');
  const rhs = payload.filter(item => item.type === 'rect');

  const renderItem = (item: (typeof payload)[number]) => (
    <Stack key={item.value} direction="row" alignItems="center" gap={0.5}>
      <Box
        sx={{
          width: 16,
          height: item.type === 'rect' ? 12 : 3,
          backgroundColor: item.color,
          borderRadius: item.type === 'rect' ? 0 : 1,
        }}
      />
      <MHMTypography variant="caption" sx={{ color: palette.text.primary }}>
        {item.value}
      </MHMTypography>
    </Stack>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        gap: 6,
        width: '100%',
        pt: 1,
      }}
    >
      <Stack direction="column" gap={0.5}>
        {lhs.map(renderItem)}
      </Stack>
      {rhs.length > 0 && (
        <Stack direction="column" gap={0.5}>
          {rhs.map(renderItem)}
        </Stack>
      )}
    </Box>
  );
};
